import { Button } from 'react-bootstrap';
import { memo, useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { toast } from 'react-toastify';
import { LiteTradeNotificationTopUpStyled } from './styled/LiteTradeNotificationTopUpStyled';
import { locationSlice } from '../../../Location/locationReducer';
import { LOCATION_NAMES } from '../../../Location/locationConstants';
import { useLangContext } from '../../../../providers/LangProvider/LangProviderContext';

function LiteTradeNotificationTopUp() {
    const dispatch = useDispatch();
    const { getLangPath } = useLangContext();

    const handleClick = useCallback(() => {
        toast.dismiss();
        dispatch(locationSlice.actions.openLocationAction({ name: LOCATION_NAMES.DEPOSIT }));
    }, [dispatch]);

    return <LiteTradeNotificationTopUpStyled>
        <Button variant="secondary" size={'sm'} onClick={handleClick}>
            {getLangPath('lite_version.home.top_up')}
        </Button>
    </LiteTradeNotificationTopUpStyled>;
}

export default memo(LiteTradeNotificationTopUp);
